import React, { useState, useEffect } from 'react';
import {FaTimes } from 'react-icons/fa';
import { Link } from "react-router-dom";

export const PopUpAds = () => {
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        const timeoutId = setTimeout(() => {
          setIsOpen(true);
          document.body.classList.add('no-scroll');
        }, 3000);
    
        return () => {
          clearTimeout(timeoutId);
        };
    }, []);
    const PopUpCLose = () => {
        setIsOpen(false);
        document.body.classList.remove('no-scroll');
    };
    return(
        <div>
            {isOpen && (
                <div className="Popup-section">
                    <div className="special-offer-section py-4">
                        <div className="container">
                            <div className="special-offer-container">
                                <div className="col-12 text-white card-top mb-5 pb-lg-5">
                                    <button className='bg-transparent border-0 text-white' onClick={PopUpCLose}><FaTimes/></button>
                                    <h2 className="text-center mb-5">SPECIAL OFFER</h2>
                                </div>
                                <div className="row pop-card-container">
                                    <div className="col-12 col-md-4 ">
                                        <div className="card-container position-relative">
                                            <div className="card card1 d-flex flex-column justify-content-center align-items-center rounded-0 border p">
                                                <h2>HTML</h2>
                                                <p className="text-white"><span>10$</span>/Page</p>
                                                <ul className="list-unstyled">
                                                    <li>Responsive Website/Pages</li>
                                                    <li>Cross-Platform Compatibility</li>
                                                    <li>User-Friendly View</li>
                                                </ul>
                                                <Link to="/contact-us" className="link btn btn-primary form-button" onClick={PopUpCLose}>View More</Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-4 ">
                                        <div className="card-container position-relative">
                                            <div className="card card1 card2 d-flex flex-column justify-content-center align-items-center rounded-0 border p">
                                                <h2>REACT</h2>
                                                <p className="text-white"><span>50$</span>/Page</p>
                                                <ul className="list-unstyled">
                                                    <li>Responsive Website/Pages</li>
                                                    <li>Cross-Platform Compatibility</li>
                                                    <li>User-Friendly View</li>
                                                </ul>
                                                <Link to="/services/Application-react-development" className="link btn btn-primary form-button" onClick={PopUpCLose}>View More</Link>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-4 ">
                                        <div className="card-container position-relative">
                                            <div className="card card1 d-flex flex-column justify-content-center align-items-center rounded-0 border p">
                                                <h2>LARAVEL</h2>
                                                <p className="text-white"><span>50$</span>/Page</p>
                                                <ul className="list-unstyled">
                                                    <li>Responsive Website/Pages</li>
                                                    <li>Cross-Platform Compatibility</li>
                                                    <li>User-Friendly View</li>
                                                </ul>
                                                <Link to="/services/Application-laravel-development" className="link btn btn-primary form-button" onClick={PopUpCLose}>View More</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};